import React from "react";
import { responsiveImage, CARD_WIDTHS } from "../../utils/responsiveImage";

/**
 * Tarjeta de promoción, en dos formas según la jerarquía:
 *
 *   destacada  → vertical, media pantalla de ancho y foto grande (Küül, Hidracolor)
 *   secundaria → apaisada, a todo el ancho y más baja (Herramientas)
 *
 * Toda la tarjeta abre las condiciones: el botón estira un pseudo-elemento por
 * encima de la tarjeta en vez de poner un onClick en el <article>. Así el clic
 * funciona en cualquier parte, pero sigue habiendo un único control real, que
 * es lo que reciben el teclado y los lectores de pantalla.
 */
const PromoCard = ({ promo, onOpenConditions }) => {

	const image = responsiveImage(promo.imagen, CARD_WIDTHS);
	const isFeatured = promo.destacada;

	const visual = (
		<div className={ `overflow-hidden bg-paper-warm ${isFeatured ? "aspect-[4/3]" : "aspect-video md:aspect-auto md:h-full"}` }>
			<img
				src={ image.src }
				srcSet={ image.srcSet }
				sizes={ isFeatured ? "(min-width: 768px) 50vw, 100vw" : "(min-width: 768px) 38vw, 100vw" }
				alt={ `Promoción de ${promo.marca}` }
				loading="lazy"
				className="h-full w-full object-cover"
			/>
		</div>
	);

	const content = (
		<div className={ `flex flex-1 flex-col p-6 lg:p-7 ${isFeatured ? "" : "md:justify-center"}` }>
			<p className="meta">{ promo.marca }</p>

			<h3 className={ `mt-3 font-bold leading-[1.02] tracking-[-.045em] ${isFeatured ? "text-[26px] lg:text-[32px]" : "text-[24px] lg:text-[28px]"}` }>
				{ promo.titulo }
			</h3>

			{
				promo.descripcion &&
					<p className="mt-3 text-sm leading-relaxed text-muted">{ promo.descripcion }</p>
			}

			{
				promo.condiciones &&
					<button
						type="button"
						className={ `text-link w-full justify-between border-t border-line pt-5 after:absolute after:inset-0 after:content-[''] ${isFeatured ? "mt-auto" : "mt-5 md:max-w-sm"}` }
						onClick={ () => onOpenConditions(promo) }
					>
						Ver condiciones
						<span className="text-link__arrow" aria-hidden="true">→</span>
					</button>
			}
		</div>
	);

	if (isFeatured) {
		return (
			<article className={ `relative flex h-full flex-col overflow-hidden border border-line bg-white transition-shadow duration-300 hover:shadow-card ${promo.condiciones ? "cursor-pointer" : ""}` }>
				{ visual }
				{ content }
			</article>
		);
	}

	return (
		<article className={ `relative grid overflow-hidden border border-line bg-white transition-shadow duration-300 hover:shadow-card md:h-[240px] md:grid-cols-[minmax(0,.36fr)_minmax(0,.64fr)] ${promo.condiciones ? "cursor-pointer" : ""}` }>
			{ visual }
			{ content }
		</article>
	);
};

export default PromoCard;
